module.exports = __webpack_public_path__ + "static/media/error.b311a0f6.jpg";